// extracted by mini-css-extract-plugin
module.exports = {"flagIcon":"VIP_style__flagIcon"};